export const API = {
    //  _        _______  _______  _______  _
    // ( \      (  ____ \(  ___  )(  ____ )( (    /|
    // | (      | (    \/| (   ) || (    )||  \  ( |
    // | |      | (__    | (___) || (____)||   \ | |
    // | |      |  __)   |  ___  ||     __)| (\ \) |
    // | |      | (      | (   ) || (\ (   | | \   |
    // | (____/\| (____/\| )   ( || ) \ \__| )  \  |
    // (_______/(_______/|/     \||/   \__/|/    )_)
    // 我的考试分页查询
    app_learn_getMyExamPage: { method: 'GET', url: '/train/exam/user/app-page' },
    // 获取我的考试详情
    app_learn_getMyExamDetail: { method: 'GET', url: '/train/exam/user/app-get' },
    // 开始考试
    app_learn_getMyExamAddUpdate: { method: 'POST', url: '/train/exam/user/paper/add-or-update' },
    // 试卷详情
    app_learn_getPaperDetail: { method: 'GET', url: '/train/exam/user/paper/get' },
    // 获取我的考试结果详情
    app_learn_paperGet: { method: 'GET', url: '/train/exam/user/paper/app-get' },
    // 课程库 列表
    getCoursePage: { method: 'GET', url: '/train/course/app-page' },
    // 详情
    getCurseDetail: { method: 'GET', url: '/train/course/app-get' },
    // 加入我课程
    createMyCourse: { method: 'POST', url: '/train/course/user/app-create' },
    // 我的课程分页
    getMyCoursePage: { method: 'GET', url: '/train/course/user/app-page' },
    // 删除我的课程
    deleteMyCourse: { method: 'DELETE', url: '/train/course/user/app-delete' },
    // 根据课程ID拿 课列表
    getLessonList: { method: 'GET', url: '/train/course/lesson/app-list' },
    // 获取课详情
    getLessonDetail: { method: 'GET', url: '/train/course/lesson/app-get' },
    // 不带章节只有课
    getCourseList: { method: 'GET', url: '/train/course/lesson/app-lesson-list' },
    // 查询课程分类列表
    getCourseCategoryList: { method: 'GET', url: '/train/course/category/app-list' },
    // 课程学习列表
    getMyStudyRecordList: { method: 'POST', url: '/train/course/lesson/user/study/app-list' },
    // 培训学习列表
    getMyTrainStudyRecordList: { method: 'POST', url: '/train/session/lesson/user/study/app-list' },
    // 新增
    createMyStudyRecord: { method: 'POST', url: '/train/course/lesson/user/study/record/app-create', loading: false },
    // 修改
    updateMyStudyRecord: { method: 'POST', url: '/train/course/lesson/user/study/record/app-update', loading: false },
    // 最近学习记录
    getMyLastViewed: { method: 'GET', url: '/train/course/user/last/viewed/app-get' },
    // 关闭最近学习记录
    closeMyLastViewed: { method: 'GET', url: '/train/course/user/last/viewed/app-close' },
    // 消息相关 列表
    getCourseNotificationPage: { method: 'GET', url: '/train/course/notification/app-page' },
    // 删除
    deleteCourseNotification: { method: 'DELETE', url: '/train/course/notification/app-deletes' },
    // 阅读
    readCourseNotification: { method: 'POST', url: '/train/course/user/notification/app-read' },
    // 未读总数
    getCourseNotificationUnread: { method: 'GET', url: '/train/course/user/notification/app-unread' },
    // 我的 学习报告
    getMyLearningReport: { method: 'GET', url: '/train/course/user/study/learning-report' },
    // 培训分页
    sessionPage: { method: 'POST', url: '/train/session/app-page' },
    // 培训详情
    sessionDetail: { method: 'GET', url: '/train/session/app-get' },
    // 培训详情列表
    sessionDetailList: { method: 'GET', url: '/train/session/lesson/app-list' },
    // 不带章节只有课
    getTrainList: { method: 'GET', url: '/train/session/lesson/app-lesson-list' },
    // 获取培训详情
    getTrainDetail: { method: 'GET', url: '/train/session/lesson/app-get' },
    // 新增
    createTrainMyStudyRecord: { method: 'POST', url: '/train/session/lesson/user/study/record/app-create', loading: false },
    // 修改
    updateTrainMyStudyRecord: { method: 'POST', url: '/train/session/lesson/user/study/record/app-update', loading: false },
    // 视频播放遥测上报
    reportVideoPlaybackTelemetry: { method: 'POST', url: '/train/playback/app/report', loading: false, silent: true },

    //   _____   ____ _____ _   _ _______ _____
    //  |  __ \ / __ \_   _| \ | |__   __/ ____|
    //  | |__) | |  | || | |  \| |  | | | (___
    //  |  ___/| |  | || | | . ` |  | |  \___ \
    //  | |    | |__| || |_| |\  |  | |  ____) |
    //  |_|     \____/_____|_| \_|  |_| |_____/
    // 商品分类列表
    getGoodsCategoryList: { method: 'GET', url: '/project/points/mall/category/app-list' },
    // 商品列表
    getGoodsList: { method: 'POST', url: '/project/points/mall/app-page' },
    // 商品详情
    getGoodsDetail: { method: 'GET', url: '/project/points/mall/app-get' },
    // 收货地址列表
    getAddressList: { method: 'GET', url: '/project/points/address/list' },
    // 新增收货地址
    createAddress: { method: 'POST', url: '/project/points/address/create' },
    // 获取地址详情
    getAddressDetail: { method: 'GET', url: '/project/points/address/get' },
    // 编辑地址
    updateAddress: { method: 'POST', url: '/project/points/address/update' },
    // 设置默认地址
    setDefaultAddress: { method: 'POST', url: '/project/points/address/update-default' },
    // 删除地址
    deleteAddress: { method: 'DELETE', url: '/project/points/address/delete' },
    // 新增订单
    createOrder: { method: 'POST', url: '/project/points/transaction/place-an-order' },
    // 我的积分
    getMyPoints: { method: 'GET', url: '/project/points/transaction/app-get-my-points' },
    // 积分记录
    getPointsRecord: { method: 'POST', url: '/project/points/transaction/app-page-points-user-detail' },
    // 订单列表
    getOrderList: { method: 'POST', url: '/project/points/transaction/app-page' },
    // 订单详情
    getOrderDetail: { method: 'GET', url: '/project/points/transaction/app-get' },
    // 更新订单地址
    updateOrderAddress: { method: 'POST', url: '/project/points/transaction/app-update-address' },
    // 取消订单
    cancelOrder: { method: 'POST', url: '/project/points/transaction/chargeback' },
    // 获取积分排行
    getPointsRank: { method: 'GET', url: '/project/points/transaction/app-points-sort' },

    //  _______  _______  _______ _________ _______  _______ _________
    // (  ____ )(  ____ )(  ___  )\__    _/(  ____ \(  ____ \\__   __/
    // | (    )|| (    )|| (   ) |   )  (  | (    \/| (    \/   ) (
    // | (____)|| (____)|| |   | |   |  |  | (__    | |         | |
    // |  _____)|     __)| |   | |   |  |  |  __)   | |         | |
    // | (      | (\ (   | |   | |   |  |  | (      | |         | |
    // | )      | ) \ \__| (___) ||\_)  )  | (____/\| (____/\   | |
    // |/       |/   \__/(_______)(____/   (_______/(_______/   )_(
    // 任务内容
    // 任务列表
    getMyTaskList: { method: 'POST', url: '/project/task/page' },
    // 任务树列表，与管理端树形查看使用同一现有接口
    getMyTaskTreeList: { method: 'POST', url: '/project/task/list' },
    // 项目详情继承项目查看权限，独立任务入口保持原权限。
    getProjectDetailTaskList: { method: 'POST', url: '/project/task/project-detail/page' },
    getProjectDetailTaskTreeList: { method: 'POST', url: '/project/task/project-detail/list' },
    // 任务类型
    getTaskType: { method: 'GET', url: '/project/task/type/page' },
    // 项目列表
    getMyProjectList: { method: 'POST', url: '/project/page' },
    // 我的项目各关系范围列表；项目管理页仍使用 getMyProjectList 查询公司全部项目。
    getMyRelatedProjectList: { method: 'GET', url: '/project/list/user/relate' },
    getMyParticipatingProjectList: { method: 'GET', url: '/project/list/user' },
    getMyResponsibleProjectList: { method: 'GET', url: '/project/list/user/manager' },
    getMyFollowProjectList: { method: 'GET', url: '/project/list/user/follow' },
    getMyInitiatedProjectList: { method: 'GET', url: '/project/list/user/promoter' },
    getMyCreatedProjectList: { method: 'GET', url: '/project/list/user/created' },
    getMyBrowsedProjectList: { method: 'GET', url: '/project/list/user/browse' },
    // 新增任务
    createTask: { method: 'POST', url: '/project/task/add-or-update' },
    // 修改任务所属项目
    changeTaskProject: { method: 'POST', url: '/project/task/change-project' },
    // 变更任务状态
    updateTaskStatus: { method: 'POST', url: '/project/task/update-status' },
    // 新增任务附件
    addFile: { method: 'POST', url: '/project/file/add' },
    // 删除附件
    deleteFile: { method: 'DELETE', url: '/project/file/delete' },
    // 任务详情
    getTaskDetail: { method: 'GET', url: '/project/task/get' },
    // 删除任务
    deleteTask: { method: 'DELETE', url: '/project/task/delete' },
    // 获取附件列表
    getFileList: { method: 'GET', url: '/project/file/list' },
    // 新增进展
    createProgress: { method: 'POST', url: '/project/trace/create' },
    // 获取进展
    getProgress: { method: 'GET', url: '/project/trace/list' },
    // 更新进展
    updateProgress: { method: 'POST', url: '/project/trace/update' },
    // 删除进展
    deleteProgress: { method: 'DELETE', url: '/project/trace/delete' },
    // 获取工时记录
    getWorkTime: { method: 'GET', url: '/project/task/task-hour-person' },
    // 添加工时
    addWorkTime: { method: 'POST', url: '/project/task/register-hour' },
    // 获取评论
    getComment: { method: 'GET', url: '/project/comment/list' },
    // 删除评论
    deleteComment: { method: 'DELETE', url: '/project/comment/delete' },
    // 添加评论
    addComment: { method: 'POST', url: '/project/comment/add' },
    // 任务统计
    getTaskStatistics: { method: 'POST', url: '/project/task/task-count' },
    // 首页项目任务统计
    homeTaskCount: { method: 'POST', url: '/project/task/home/task-count' },
    // 首页今日待办日期范围
    homeTaskToDoTime: { method: 'POST', url: '/project/task/home/to-do/task-time' },
    // 首页今日待办列表
    homeTaskToDoList: { method: 'POST', url: '/project/task/home/to-do/task-list' },
    // 子任务统计
    getChildTaskStatistics: { method: 'POST', url: '/project/task/task-status-count' },
    // 任务树形数据
    getTaskTree: { method: 'POST', url: '/project/task/list-tab' },
    // 讨论课程信息
    getCourseUser: { method: 'GET', url: '/train/course/lesson/user/study/get-course-user-study' },
    // 讨论培训任务
    getSessionUser: { method: 'GET', url: '/train/session/lesson/user/study/get-session-user-study' },
    // 获取培训考试id
    getUserId: { method: 'POST', url: '/train/exam/user/app-get-user-id' },
    // 获取评论详情
    getCommentDetail: { method: 'GET', url: '/project/comment/get' },
    // 点赞
    getLike: { method: 'POST', url: '/project/like/like' },
    // 取消点赞
    getUnLike: { method: 'POST', url: '/project/like/unlike' },
    // 获取课程评论
    getCommentCourse: { method: 'GET', url: '/project/comment/list-course' },
    // 获取培训评论
    getCommentSession: { method: 'GET', url: '/project/comment/list-session' },
    // 项目内容
    // 新增项目
    createProject: { method: 'POST', url: '/project/create' },
    // 检查项目重复风险
    checkProjectDuplicate: { method: 'POST', url: '/project/check-duplicate' },
    // 项目详情
    getProjectDetail: { method: 'GET', url: '/project/get' },
    // 获取项目分类
    getProjectCategory: { method: 'GET', url: '/project/catgory/list' },
    // 项目分类统计（与管理端分类视图一致）
    getProjectCategoryStatistics: { method: 'GET', url: '/project/catgory/statistics' },
    getKeyProjectPage: { method: 'POST', url: '/project/management-extension/key-project/page' },
    getRiskProjectPage: { method: 'GET', url: '/project/risk/page' },
    getMyRiskProjectPage: { method: 'GET', url: '/project/risk/my-project-page' },
    getMyRelatedRiskProjectPage: { method: 'GET', url: '/project/risk/my-related-project-page' },
    getContractOverviewPage: { method: 'POST', url: '/project/management-extension/contract-overview/page' },
    // 更新项目详情
    updateProjectDetail: { method: 'POST', url: '/project/update' },
    // 获取流程模板
    getFlowList: { method: 'POST', url: '/project/template/flow/list' },
    // 关注项目
    followProject: { method: 'POST', url: '/project/follow/follow' },
    // 取消关注
    unfollowProject: { method: 'POST', url: '/project/follow/unfollow' },
    // 删除项目
    deleteProject: { method: 'DELETE', url: '/project/delete' },
    // 项目状态变更
    updateProjectStatus: { method: 'POST', url: '/project/update-status' },
    // 转为立项
    turnToLaunch: { method: 'POST', url: '/project/wander' },
    // 获取项目工时列表
    getProjectWorkTime: { method: 'POST', url: '/project/task/task-hour' },
    // 获取项目工时统计
    getProjectWorkTimeCount: { method: 'POST', url: '/project/task/task-hour-count' },
    // 删除工时
    deleteWorkTime: { method: 'DELETE', url: '/project/task/delete-hour' },
    // 工时更新
    updateWorkTime: { method: 'POST', url: '/project/task/task-hour-update' },
    // 项目统计
    getProjectStatistics: { method: 'POST', url: '/project/my-statics' },
    // 查询用户管理列表
    getUserList: { method: 'GET', url: '/system/user/page' },
    // 查询用户管理 all
    getUsers: { method: 'GET', url: '/system/user/list' },
    // 查询项目成员列表
    getProjectUserList: { method: 'GET', url: '/project/user/project-users' },
    // 删除项目成员
    deleteProjectUser: { method: 'POST', url: '/project/user/delete' },
    // 查询成员信息
    getUserInfo: { method: 'GET', url: '/project/user/project-user-list/role' },
    // 添加项目成员
    addProjectUser: { method: 'POST', url: '/project/user/batch-add' },
    // 修改项目发起人
    updateProjectPromoter: { method: 'POST', url: '/project/user/batch-update' },
    // 获取文件预签名地址
    getFilePresignedUrl: { method: 'GET', url: '/infra/file/presigned-url' },
    // 创建文件
    createFile: { method: 'POST', url: '/infra/file/create-return-object' },
    // 客户列表
    getCustomerList: { method: 'GET', url: '/project/customer/list' },
    // 客户联系人列表
    getContactList: { method: 'GET', url: '/project/customer/contact/list' },
    // 获取项目日志
    getProjectLogsList: { method: 'POST', url: '/project/op/log/list' },
    // 分页获取项目日志
    getProjectLogsPage: { method: 'POST', url: '/project/op/log/page' },
    // 客户列表
    getCustomerByProjectId: { method: 'GET', url: '/project/customer/relevance/list' },
    // 创建或更新客户
    createOrUpdateContract: { method: 'POST', url: '/project/customer/relevance/create-or-update' },
    // 删除客户
    deleteCustomer: { method: 'DELETE', url: '/project/customer/relevance/delete' },
    // 合同列表
    getContractList: { method: 'POST', url: '/project/contract/app/page' },
    // 合同列表
    getContractByProjectId: { method: 'GET', url: '/project/contract/app/list' },
    // 删除合同
    relieveContract: { method: 'GET', url: '/project/contract/app/relieve' },
    // 绑定合同
    bindContract: { method: 'POST', url: '/project/contract/app/bind' },
    // 合同统计
    covenantStatics: { method: 'GET', url: '/project/contract/covenant/statics' },
    covenantStaticsCond: { method: 'POST', url: '/project/contract/covenant/statics-cond' },
    covenantPlanTrend: { method: 'POST', url: '/project/contract/plan/trend' },
    covenanDeptStaticd: { method: 'POST', url: '/project/contract/plan/deptStatic' },
    // 核销记录分页查询
    getPlanPinPage: { method: 'POST', url: '/project/contract/plan-pin/page' },

    //  _______  _______  _______           _______  _        _______
    // |\     /|(  ___  )(  ____ )| \    /\(  ____ \( \      (  ___  )|\     /|
    // | )   ( || (   ) || (    )||  \  / /| (    \/| (      | (   ) || )   ( |
    // | | _ | || |   | || (____)||  (_/ / | (__    | |      | |   | || | _ | |
    // | |( )| || |   | ||     __)|   _ (  |  __)   | |      | |   | || |( )| |
    // | || || || |   | || (\ (   |  ( \ \ | (      | |      | |   | || || || |
    // | () () || (___) || ) \ \__|  /  \ \| )      | (____/\| (___) || () () |
    // (_______)(_______)|/   \__/|_/    \/|/       (_______/(_______)(_______)

    // ----审核相关接口
    // 发起审核列表
    listCurrentUserStartGroup: { method: 'GET', url: '/bpm/workflow/processGroup/listCurrentUserStartGroup' },
    // 流程管理列表
    listGroupWithProcessMain: { method: 'GET', url: '/bpm/workflow/processGroup/listGroupWithProcessMain' },
    // 我发起的审核列表
    startedList: { method: 'POST', url: '/bpm/workflow/process-instance/started-list' },
    // 已提交的的审核列表
    completedList: { method: 'POST', url: '/bpm/workflow/process-instance/completed-ist' },
    //    抄送我的
    ccList: { method: 'POST', url: '/bpm/workflow/process-instance/cc-list' },
    // 待处理的
    todoList: { method: 'POST', url: '/bpm/workflow/process-instance/todo-list' },
    // 获取表单详情
    getFormDetail: { method: 'POST', url: '/bpm/workflow/form/getFormDetail' },
    // 获取流程详情-表头
    getHeader: { method: 'POST', url: '/bpm/workflow/process-instance/getHeader' },
    // 获取流程详情-流程图
    getFormatNode: { method: 'POST', url: '/bpm/workflow/process-instance/getFormatNode' },
    // 发布审核
    startProcessInstance: { method: 'POST', url: '/bpm/workflow/process-instance/startProcessInstance' },
    // 撤销
    revoke: { method: 'POST', url: '/bpm/workflow/task/revoke' },
    // 同意
    completeTask: { method: 'POST', url: '/bpm/workflow/task/completeTask' },
    // 加签
    addSign: { method: 'POST', url: '/bpm/workflow/task/add/approver' },
    // 转审
    transfer: { method: 'POST', url: '/bpm/workflow/task/delegate' },
    // 标记已读
    read: { method: 'POST', url: '/bpm/workflow/task/cc/read' },
    // 获取详情
    contract: { method: 'GET', url: '/project/contract/covenant/get' },
    // 获取档案详情
    borrow: { method: 'GET', url: '/project/archive/borrow/get' },
    // 获取应用列表-用户端
    getAiAppList: { method: 'GET', url: '/ai/app/list-simple' },
    // 获取部门列表 精简
    getDeptList: { method: 'GET', url: '/system/dept/list' },

    //  _______  _______  _______  _______  _______
    // (  ____ )(  ___  )(  ____ )(  ____ \(  ____ )
    // | (    )|| (   ) || (    )|| (    \/| (    )|
    // | (____)|| (___) || (____)|| (__    | (____)|
    // |  _____)|  ___  ||  _____)|  __)   |     __)
    // | (      | (   ) || (      | (      | (\ (
    // | )      | )   ( || )      | (____/\| ) \ \__
    // |/       |/     \||/       (_______/|/   \__/
    // 生成日报
    paperGenerate: { method: 'POST', url: '/project/paper/generate' },
    // 创建汇报人
    accepterBatchCreate: { method: 'POST', url: '/project/paper/accepter/app/batch-create' },
    // 删除汇报人
    accepterDel: { method: 'DELETE', url: '/project/paper/accepter/delete' },
    // 获取汇报人列表
    accepterList: { method: 'GET', url: '/project/paper/accepter/list' },
    // 更新日报
    paperGenerateUpdate: { method: 'POST', url: '/project/paper/update' },
    // 创建日报
    paperCreate: { method: 'POST', url: '/project/paper/create' },
    // 定时保存
    paperTemporaryStorage: { method: 'POST', url: '/project/paper/temporary-storage' },
    // 获取最新暂存
    paperTemporaryStorageGet: { method: 'POST', url: '/project/paper/temporary-storage/get' },
    // 更新任务
    paperPerceiveUpdate: { method: 'POST', url: '/project/paper/update/perceive' },
    // 导入上篇
    recentApi: { method: 'GET', url: '/project/paper/recent' },
    // 我的日报列表
    paperPage: { method: 'POST', url: '/project/paper/page' },
    // 我收到的日报列表
    paperGroupTime: { method: 'POST', url: '/project/paper/accepter/page-group-time' },
    // 我收到的-人员列表
    paperAccepterPage: { method: 'GET', url: '/project/paper/accepter/page' },
    // 我的日报详情
    paperPageGet: { method: 'GET', url: '/project/paper/get' },
    // 更新接收人信息
    paperAccepterUpdate: { method: 'POST', url: '/project/paper/accepter/update' },
    // 汇报统计列表-按人员
    paperStatistics: { method: 'POST', url: '/project/paper/dept-list' },
    // 汇报统计列表-按人员-改
    paperStatisticsUser: { method: 'POST', url: '/project/paper/dept-list-user' },
    // 汇报统计列表-按人员-人员列表
    paperStatisticsDeptPage: { method: 'POST', url: '/project/paper/dept-page' },
    // 汇报统计列表-按人员-详情
    paperStatisticsDayDeptPage: { method: 'POST', url: '/project/paper/dept-user-day-page' },
    // 汇报统计列表-按日期
    paperStatisticsDate: { method: 'POST', url: '/project/paper/date-page' },

    //     _____ ____  _   _ _______ _____            _____ _______
    //   / ____/ __ \| \ | |__   __|  __ \     /\   / ____|__   __|
    //  | |   | |  | |  \| |  | |  | |__) |   /  \ | |       | |
    //  | |   | |  | | . ` |  | |  |  _  /   / /\ \| |       | |
    //  | |___| |__| | |\  |  | |  | | \ \  / ____ \ |____   | |
    //   \_____\____/|_| \_|  |_|  |_|  \_\/_/    \_\_____|  |_|
    covenantPage: { method: 'POST', url: '/project/contract/covenant/page' },
    innerBodyPage: { method: 'GET', url: '/project/contract/inner-body/page' },
    innerBodyPageCustomer: { method: 'GET', url: '/project/contract/inner-body/page/customer' },
    getCategoryList: { method: 'GET', url: '/project/contract/category/list-category' },
    // 起草合同-创建
    covenantCreate: { method: 'POST', url: '/project/contract/covenant/create' },
    // 获取合同信息
    covenantGet: { method: 'GET', url: '/project/contract/covenant/get' },
    // 起草合同-更新
    covenantUpdate: { method: 'POST', url: '/project/contract/covenant/update' },
    // 保存分享人
    shareCreate: { method: 'POST', url: '/project/contract/share/create' },
    // 编辑分享人
    shareUpdate: { method: 'POST', url: '/project/contract/share/update' },
    // 删除分享人
    shareDelete: { method: 'DELETE', url: '/project/contract/share/delete' },

    //   ____   ____  _____  _____   ______          __
    //  |  _ \ / __ \|  __ \|  __ \ / __ \ \        / /
    //  | |_) | |  | | |__) | |__) | |  | \ \  /\  / /
    //  |  _ <| |  | |  _  /|  _  /| |  | |\ \/  \/ /
    //  | |_) | |__| | | \ \| | \ \| |__| | \  /\  /
    //  |____/ \____/|_|  \_\_|  \_\\____/   \/  \/
    // 档案借阅列表
    borrowPage: { method: 'POST', url: '/project/archive/manager/borrow-page' },
    // 我的借阅列表
    inventoryPage: { method: 'POST', url: '/project/archive/borrow/inventory/page' },
    // 借阅申请
    createBorrow: { method: 'POST', url: '/project/archive/borrow/create-or-update' },
    // 借阅申请列表
    borrowList: { method: 'POST', url: '/project/archive/borrow/page' },
    // 归还申请列表
    backBorrowList: { method: 'POST', url: '/project/archive/borrow/page-back' },
    // 档案详情
    filesGet: { method: 'GET', url: '/project/archive/manager/get' },
    // 获取审核模版信息
    processFlowGet: { method: 'GET', url: '/project/archive/approval/process/get-flow-type' },
    // 获取筛选模版列表
    getArchiveTemplateList: { method: 'GET', url: '/project/archive/template/list' },
    // 获取档案模板列表及已启用字段，供高级筛选使用
    getArchiveTemplateListOpen: { method: 'GET', url: '/project/archive/template/list/open' },
    // 获取筛选模版模块配置
    getArchiveTemplateModule: { method: 'GET', url: '/project/show/template/get_module' },
    // 更新筛选模版模块配置
    updateArchiveTemplateModule: { method: 'POST', url: '/project/show/template/update' },
    // 查阅文件
    getPreviewFileId: { method: 'GET', url: '/project/contract/annex/preview-file-id' },
    // 查阅文件
    getPreviewId: { method: 'GET', url: '/project/archive/annex/preview' },
    // 审批详情
    getProcessTasks: { method: 'GET', url: '/bpm/workflow/process-instance/getProcessInstance' },

    //    _____ _____  __  __
    //   / ____|  __ \|  \/  |
    //  | |    | |__) | \  / |
    //  | |    |  _  /| |\/| |
    //  | |____| | \ \| |  | |
    //   \_____|_|  \_\_|  |_|
    // 客户列表
    getAllCustomer: { method: 'POST', url: '/project/customer/page' },
    // 创建客户
    createCustomer: { method: 'POST', url: '/project/customer/create' },
    // 查询客户详情
    getCustomerDetail: { method: 'GET', url: '/project/customer/get' },
    // 更新客户详情
    updateCustomer: { method: 'POST', url: '/project/customer/update' },
    // 查询客户联系人列表
    getContactData: { method: 'POST', url: '/project/customer/contact/page' },
    // 查询客户联系人列表
    getContactDataDetail: { method: 'GET', url: '/project/customer/contact/get' },
    // 查询客户联系人列表-用于下拉选
    getContactListForSelect: { method: 'GET', url: '/project/customer/contact/customer-contract-list' },
    // 更新主要联系人
    updateContactFirstStatus: { method: 'PUT', url: '/project/customer/contact/update_first_status' },
    // 删除客户联系人
    deleteContact: { method: 'DELETE', url: '/project/customer/contact/delete' },
    // 创建客户联系人
    createContact: { method: 'POST', url: '/project/customer/contact/create' },
    // 查询客户联系人详情
    getContactDetail: { method: 'GET', url: '/project/customer/contact/get' },
    // 更新客户联系人
    updateContact: { method: 'POST', url: '/project/customer/contact/update' },
    // 查询协作人用户列表
    getCollaboratorList: { method: 'POST', url: '/project/customer/user/page' },
    // 查询协作人用户列表
    getCollaboratorDetail: { method: 'GET', url: '/project/customer/user/get' },
    // 批量添加协作人（整体更新）
    batchAddCollaborator: { method: 'POST', url: '/project/customer/user/create_batch' },
    // 批量添加协作人（只能添加）
    batchAddCollaboratorOnly: { method: 'POST', url: '/project/customer/user/create_or_update_batch' },
    // 单独添加协作人
    addCollaborator: { method: 'POST', url: '/project/customer/user/create' },
    // 更新协作人信息
    updateCollaborator: { method: 'POST', url: '/project/customer/user/update' },
    // 删除协作人信息
    deleteCollaborator: { method: 'DELETE', url: '/project/customer/user/delete' },

    // 变更负责人
    changeLeader: { method: 'POST', url: '/project/customer/user/update_manager' },
    // 删除客户
    delCustomer: { method: 'DELETE', url: '/project/customer/delete' },
    // 查询跟进记录列表
    getFollowList: { method: 'POST', url: '/project/customer/follow/page' },
    // 创建跟进记录
    createFollow: { method: 'POST', url: '/project/customer/follow/create' },
    // 跟进记录详情
    getFollowRecord: { method: 'GET', url: '/project/customer/follow/get' },
    // 更新跟进记录
    updateFollow: { method: 'POST', url: '/project/customer/follow/update' },
    // 删除跟进记录
    deleteFollow: { method: 'DELETE', url: '/project/customer/follow/delete' },
    // 创建拜访计划
    createVisitPlan: { method: 'POST', url: '/project/customer/visit/create' },
    // 更新拜访计划
    updateVisitPlan: { method: 'POST', url: '/project/customer/visit/update' },
    // 删除拜访计划
    deleteVisitPlan: { method: 'DELETE', url: '/project/customer/visit/delete' },
    // 查询拜访计划列表
    getVisitPlanList: { method: 'POST', url: '/project/customer/visit/page' },
    // 查询拜访计划详情
    getVisitPlanDetail: { method: 'GET', url: '/project/customer/visit/get' },
    // 创建拜访计划记录
    createVisitPlanRecord: { method: 'POST', url: '/project/customer/visit/record/create' },
    // 更新拜访计划记录
    updateVisitPlanRecord: { method: 'POST', url: '/project/customer/visit/record/update' },
    // 删除拜访计划记录
    deleteVisitPlanRecord: { method: 'DELETE', url: '/project/customer/visit/record/delete' },
    // 关注
    follow: { method: 'POST', url: '/project/customer/user/follow' },
    // 取消关注
    unfollow: { method: 'POST', url: '/project/customer/user/unfollow' },
    // 商机类型列表
    getBusinessTypeList: { method: 'POST', url: '/project/customer/business/stage/template/page' },
    // 新增商机
    createBusiness: { method: 'POST', url: '/project/customer/business/create' },
    // 更新商机
    updateBusiness: { method: 'POST', url: '/project/customer/business/update' },
    // 删除商机
    deleteBusiness: { method: 'DELETE', url: '/project/customer/business/delete' },
    // 商机列表
    getBusinessList: { method: 'POST', url: '/project/customer/business/page' },
    // 商机详情
    getBusinessDetail: { method: 'GET', url: '/project/customer/business/get' },
    // 更新商机阶段
    updateStage: { method: 'POST', url: '/project/customer/business/stage/update_stage' },
    // 线索列表
    getClueList: { method: 'POST', url: '/project/customer/clue/page' },
    // 创建线索
    createClue: { method: 'POST', url: '/project/customer/clue/create' },
    // 更新线索
    updateClue: { method: 'POST', url: '/project/customer/clue/update' },
    // 线索详情
    getClueDetail: { method: 'GET', url: '/project/customer/clue/get' },
    // 删除线索
    deleteClue: { method: 'DELETE', url: '/project/customer/clue/delete' },
    // 线索状态变更
    updateClueStatus: { method: 'POST', url: '/project/customer/clue/status' },
    // 线索转客户
    clueToCustomer: { method: 'POST', url: '/project/customer/clue/to-consumer' },
    // 客户（线索）查重
    checkRepeat: { method: 'GET', url: '/project/customer/repeat-list' },
    // 联系人查重
    checkContactRepeat: { method: 'GET', url: '/project/customer/contact/repeat-list' },
    // 删除附件
    deleteFollowFile: { method: 'DELETE', url: '/project/customer/file/delete' },
    // 按签约方分页
    // topicId 关联ID inner_body_id（内部主体ID）customer_id（客户id）
    // type 签约人类型 0-内部主体 1-客户
    signatoryPage: { method: 'GET', url: '/project/contract/covenant/signatory-page' },
    // businessId=13
    passPage: { method: 'GET', url: '/project/contract/covenant/page-pass' },
    // 关联商机列表 customerIds
    businessListDown: { method: 'POST', url: '/project/customer/business/list-down' },
    // 合同协作人列表
    contractUserPage: { method: 'POST', url: '/project/covenant/user/page' },
    // 删除合同协作人
    deleteContractUser: { method: 'DELETE', url: '/project/covenant/user/delete' },
    // 批量添加协作人合同协作人（只能添加）
    batchAddCovenantUser: { method: 'POST', url: '/project/covenant/user/create_or_update_batch' },
    // 删除合同
    deleteCovenantUser: { method: 'DELETE', url: '/project/contract/covenant/delete' },

    //   _____                      _
    //  |_   _|                    | |
    //    | |  _ ____   _____ _ __ | |_ ___  _ __ _   _
    //    | | | '_ \ \ / / _ \ '_ \| __/ _ \| '__| | | |
    //   _| |_| | | \ V /  __/ | | | || (_) | |  | |_| |
    //  |_____|_| |_|\_/ \___|_| |_|\__\___/|_|   \__, |
    //                                             __/ |
    //                                            |___/
    // 仓库列表
    warehouseList: { method: 'GET', url: '/erp/warehouse/list' },
    // 仓库列表分页
    warehousePage: { method: 'GET', url: '/erp/warehouse/page' },
    // 新增入库单
    createInbound: { method: 'POST', url: '/erp/stock/in/order/create' },
    // 查询库存
    getInventory: { method: 'GET', url: '/erp/inventory/list' },
    // 选择物料
    materialPage: { method: 'GET', url: '/erp/material/page' },
    // 新增出库单
    createOutbound: { method: 'POST', url: '/erp/stock/out/order/create' },
    // 供应商列表
    supplierPage: { method: 'POST', url: '/purchase/supplier/page' },
    // 入库单列表
    inboundPage: { method: 'POST', url: '/erp/stock/in/order/page' },
    // 获取入库单详情
    getInboundDetail: { method: 'GET', url: '/erp/stock/in/order/get' },
    // 获取出库单详情
    getOutboundDetail: { method: 'GET', url: '/erp/stock/out/order/get' },
    // 获取调拨单详情
    getTransferDetail: { method: 'GET', url: '/erp/allocation/get' },
    // 新增调拨单
    createTransfer: { method: 'POST', url: '/erp/allocation/create' },
    // 出库单
    outboundPage: { method: 'POST', url: '/erp/stock/out/order/page' },
    // 调拨单列表
    transferPage: { method: 'POST', url: '/erp/allocation/page' },
    // 入库冲销
    inboundDestruction: { method: 'GET', url: '/erp/stock/in/order/destruction' },
    // 出库冲销
    outboundDestruction: { method: 'GET', url: '/erp/stock/out/order/destruction' },
    // 更新附件 deleteList:删除列表 fileList: 文件列表
    updateAnnex: { method: 'POST', url: '/project/contract/annex/batch-create-or-update' }

}
